import { SEO, SITE_URL, HOME_LANGS, hreflangLinks } from "@/i18n/seo";

const setAttr = (selector, attr, value) => {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute(attr, value);
};

// Keeps the live <head> in sync with the pre-rendered HTML for each public URL.
export const applySeoHead = (key) => {
  const p = SEO[key];
  const url = SITE_URL + p.path;
  document.documentElement.lang = p.lang;
  document.title = p.title;
  setAttr('meta[name="description"]', "content", p.description);
  setAttr('link[rel="canonical"]', "href", url);
  setAttr('meta[property="og:url"]', "content", url);
  setAttr('meta[property="og:title"]', "content", p.title);
  setAttr('meta[property="og:description"]', "content", p.description);
  setAttr('meta[property="og:locale"]', "content", p.locale);
  setAttr('meta[name="twitter:title"]', "content", p.title);
  setAttr('meta[name="twitter:description"]', "content", p.description);
  document.head.querySelectorAll("link[hreflang]").forEach((l) => l.remove());
  if (!HOME_LANGS.includes(key)) return;
  hreflangLinks().forEach(({ hreflang, href }) => {
    const link = document.createElement("link");
    link.rel = "alternate";
    link.hreflang = hreflang;
    link.href = href;
    document.head.appendChild(link);
  });
};
